import styled from 'styled-components';

import {mixins} from '@edna/components/styles';

export const EmptyImage = styled.div`
  ${mixins.wh('200px')}
  ${mixins.flexAlign('center')}
`;
